import { render, staticRenderFns } from "./weekreport.vue?vue&type=template&id=663457b2&scoped=true&"
import script from "./weekreport.vue?vue&type=script&lang=js&"
export * from "./weekreport.vue?vue&type=script&lang=js&"
import style0 from "./weekreport.vue?vue&type=style&index=0&id=663457b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663457b2",
  null
  
)

export default component.exports